module.exports = __webpack_public_path__ + "img/375.654deea6.jpg";